import React from 'react';
const AI2SVG = ({ color = '#682ECB', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='11'
      height='11'
      viewBox='0 0 11 11'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M1.75 10.5V8M1.75 3V0.5M0.5 1.75H3M0.5 9.25H3M6 1L5.1329 3.25443C4.9919 3.62105 4.9214 3.80436 4.81175 3.95855C4.7146 4.0952 4.5952 4.2146 4.45855 4.31177C4.30436 4.42141 4.12104 4.49191 3.75443 4.6329L1.5 5.5L3.75443 6.3671C4.12104 6.5081 4.30436 6.5786 4.45855 6.68825C4.5952 6.7854 4.7146 6.9048 4.81175 7.04145C4.9214 7.19565 4.9919 7.37895 5.1329 7.74555L6 10L6.8671 7.74555C7.0081 7.37895 7.0786 7.19565 7.18825 7.04145C7.2854 6.9048 7.4048 6.7854 7.54145 6.68825C7.69565 6.5786 7.87895 6.5081 8.24555 6.3671L10.5 5.5L8.24555 4.6329C7.87895 4.49191 7.69565 4.4214 7.54145 4.31177C7.4048 4.2146 7.2854 4.0952 7.18825 3.95855C7.0786 3.80436 7.0081 3.62105 6.8671 3.25443L6 1Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default AI2SVG;
